import { defineStore } from 'pinia'
import { HttpMethod, useApi } from '~/utils/FetchApi'
import { BackgroundRemovalStatus } from '~/static/enums/image/background-removal-status'
import { track } from '~/utils/Amplitude'

interface ImageStore {
  originalName: string | null
  imageUrl: string | null
  imageWithoutBackgroundUrl: string | null
  backgroundRemovalStatus: BackgroundRemovalStatus
  taskUuid: string | null
  getImageInterval: NodeJS.Timeout | null
  designsCreated: boolean
}

export const useRemovalBackgroundStore = defineStore('removal-background', {
  state: (): ImageStore => {
    return {
      originalName: null,
      imageUrl: null,
      imageWithoutBackgroundUrl: null,
      backgroundRemovalStatus: BackgroundRemovalStatus.Pending,
      taskUuid: null,
      getImageInterval: null,
      designsCreated: false,
    }
  },
  actions: {
    async loadImageWithBackgroundRemoved(image: File): Promise<void> {
      // 15728640 is 15Mb
      if (image.size >= 15728640) {
        useNuxtApp().$event('popup:show', {
          text: 'Максимальный размер фото 15 МБ',
        })
        return Promise.reject()
      }

      const uploadForm = new FormData()
      uploadForm.append('image', image)

      interface LoadImageWithBackgroundRemovedResponse {
        task_uuid: string
        url: string
      }

      this.imageUrl = URL.createObjectURL(image)
      this.backgroundRemovalStatus = BackgroundRemovalStatus.Pending
      const { response, error } = await useApi<LoadImageWithBackgroundRemovedResponse>(
        'card.loadImageWithBackgroundRemoved',
        {},
        HttpMethod.POST,
        uploadForm,
      )

      if (error) {
        // eslint-disable-next-line no-console
        console.log(error.error_code, error.error_msg)
      } else {
        this.originalName = image.name
        this.taskUuid = response.task_uuid
        this.imageUrl = response.url
        this.designsCreated = false
        track('Image loading')
        await this.checkBackgroundRemovalTask()
        return Promise.resolve()
      }
      return Promise.reject()
    },
    async checkBackgroundRemovalTask() {
      this.getImageInterval = setInterval(this.getImageWithBackgroundRemoved, 1000)
    },
    async getImageWithBackgroundRemoved() {
      interface GetImageResponse {
        status: BackgroundRemovalStatus
        url: string | null
      }

      const { response, error } = await useApi<GetImageResponse>('card.getImageWithBackgroundRemoved', {
        task_uuid: this.taskUuid,
      })
      if (error) {
        // eslint-disable-next-line no-console
        console.log(error.error_code, error.error_msg)
        clearInterval(<NodeJS.Timeout>this.getImageInterval)
        this.getImageInterval = null
      } else {
        this.backgroundRemovalStatus = response.status
        this.imageWithoutBackgroundUrl = response.url
        if (response.status !== BackgroundRemovalStatus.Pending) {
          clearInterval(<NodeJS.Timeout>this.getImageInterval)
          this.getImageInterval = null
        }
      }
    },
  },
})
